import React from "react";
import { MoreVertical, ExternalLink } from "lucide-react";

export default function StoreRow({
  store,
  isOpen,
  anchorRef,
  onToggle,
  onOpenDiscount,
  onAccessApp,
}) {
  const getStatusColor = (status) => {
    switch (status) {
      case "Paid":
        return "bg-green-100 text-green-800";
      case "Trial":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <tr className="hover:bg-gray-50">
      <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">
        {store.username}
      </td>
      <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">
        {store.email}
      </td>
      <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">
        {new Date(store.createdAt).toLocaleDateString()}
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <span
          className={`w-20 inline-flex justify-center text-xs leading-6 font-semibold rounded-full ${getStatusColor(
            store.onTrial ? "Trial" : "Paid"
          )}`}
        >
          {store.onTrial ? "Trial" : "Paid"}
        </span>
      </td>
      <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap capitalize">
        {store.currentPlan}
      </td>
      <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">
        {store.shopName}
      </td>
      <td className="px-6 py-4 text-sm text-gray-900 whitespace-nowrap">
        ${store.totalBill?.amount || 0}
      </td>
      <td className="px-6 py-4 text-sm font-medium whitespace-nowrap">
        <div className="relative flex justify-end" ref={anchorRef}>
          <button
            onClick={onToggle}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <MoreVertical size={20} />
          </button>
          {isOpen && (
            <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
              <div className="py-1">
                <button
                  onClick={onAccessApp}
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <ExternalLink className="mr-2 h-4 w-4" />
                  Access App
                </button>
                <button
                  onClick={onOpenDiscount}
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Apply Discount
                </button>
              </div>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}
